import { Login } from "@/components/login/Login";
import type { NextPageProps } from "@/pages/_app";
import type { NextPage } from "next";
import Head from "next/head";
import useTranslation from "next-translate/useTranslation";
import { OGPPayments } from "@/components/ogp-payments/ogp-payments";
import { StreamName, useRegisterStream } from "@/modules/analytics";
import { OGImage } from "@/components/og-image/og-image";
import { useEffect, useState } from "react";
import { MEDIA_QUERY_MIN_WIDTH } from "@/constants/media-query.constant";
import { useScreenResize } from "@/components/login/LoginInfoMessage/useScreenResize";

const SignIn: NextPage<NextPageProps> = () => {
  const { t } = useTranslation("web-payments");
  useRegisterStream(StreamName.SignIn);
  const [isBigScreen, setIsBigScreen] = useState(false);

  useEffect(() => {
    if (window.innerWidth >= MEDIA_QUERY_MIN_WIDTH.mobile) {
      setIsBigScreen(true);
    }
  }, []);

  // 768px is the breakpoint for tablet portrait
  useScreenResize(MEDIA_QUERY_MIN_WIDTH.mobile, setIsBigScreen);
  return (
    <>
      <Head>
        <title>{`${t`SSO_SIGN_UP`} | OneFootball`}</title>
        <OGPPayments
          title={t`OG_TITLE_PAGE_SIGN_IN`}
          description="OneFootball"
        />
        <OGImage />
      </Head>
      <div>
        <Login signIn isBigScreen={isBigScreen} />
      </div>
    </>
  );
};

export default SignIn;
